import { type Step } from "./types";

export const getActiveStepIndex = (activeStep: string, steps: Step<any>[]) => {
  return steps.map((e) => e.value).indexOf(activeStep);
};
